import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { CONFIRM_GENERIC_ERROR } from "@constants/cambio-via-pago-properties.constants";
import { BASIC_CLIENT_INFO } from "@constants/data-service.constant";
import { BENEFICIO_SELECCIONADO_REFORMAS, CARD_REFORMA_PENSIONES, FiltroSexosBeneficio, ICardReformaPensiones, NO_APLICA_BENEFICIOS_REFORMA_PENSIONES_MENSAJE, TiposTextosImportanteReformaPensiones } from "@constants/reforma-pensiones.constants";
import { RESPONSE_BENEFICIOS_REFORMA_PENSIONES } from "@constants/tramite-pension-constant";
import { INICIO, ROUTING_REFORMA_PENSIONES } from "@constants/url.constant";
import { IBeneficiosReforma } from "@interfaces/beneficios-reforma.response.interface";
import { StorageService } from "@services/storage/storage.service";
import { IRightColumnData } from "@shared/common/interfaces/right-column-data.interface";
import { Util } from "@shared/common/utils/util";
import { GenericErrorOps } from "@shared/components/generic-error/interfaces/generic-error-ops.interface";
import { Subscription } from "rxjs";
import { ReformaPensionesService } from "../../services/reforma-pensiones.service";
@Component({
  selector: "app-reforma-pensiones-home",
  templateUrl: "./reforma-pensiones-home.component.html",
  styleUrl: "./reforma-pensiones-home.component.scss",
  standalone: false
})
export class ReformaPensionesHomeComponent implements OnInit, OnDestroy {
  loadingHome: boolean = true;
  showComponent: boolean = true;
  showErrorScreen: boolean = false;
  servsError: boolean = false;
  rightColumnData: IRightColumnData[] = [];
  public errorOps: GenericErrorOps = CONFIRM_GENERIC_ERROR;
  attempt: boolean = false;
  nAttempts: number = 1;
  private routerSubscription: Subscription;
  token: string = '';
  cardDataReformaPensiones = CARD_REFORMA_PENSIONES;
  isMobile: boolean = false;
  isOpenHelp: boolean = false;
  tipoBeneficios = TiposTextosImportanteReformaPensiones.PaginaBeneficiosReforma;
  codigosBackBeneficiosOtorgados: string[] = [];

  constructor(private readonly router: Router,
    private readonly reformaPensionesService: ReformaPensionesService,
    private readonly util: Util,
    private readonly storageService: StorageService,
  ) { }

  ionViewWillEnter(): void {
    this.initializeComponent();
  }

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        event.urlAfterRedirects.includes("reforma-pensiones")
      ) {
        this.initializeComponent();
      }
    });
  }

  private initializeComponent(): void {
    this.loadingHome = true;
    this.isMobile = window.innerWidth < 840;
    void this.getBeneficiosReformaPensiones();
  }

  async getBeneficiosReformaPensiones() {
    try {
      this.attempt = true;
      this.token = await this.util.getIdToken();

      let response: IBeneficiosReforma[] = [];

      // Intenta obtener los beneficios desde el storage primero
      const cachedResponse = await this.storageService.get(RESPONSE_BENEFICIOS_REFORMA_PENSIONES);

      if (Array.isArray(cachedResponse) && cachedResponse) {
        response = cachedResponse;
      } else {
        response = await this.reformaPensionesService.getBeneficiosReformaPensiones(this.token);
        await this.storageService.set(RESPONSE_BENEFICIOS_REFORMA_PENSIONES, response);
      }

      const { gender } = await this.storageService.get(BASIC_CLIENT_INFO);

      this.cardDataReformaPensiones = CARD_REFORMA_PENSIONES
        .filter(card =>
          // 1. filtro por sexo
          card.sex === FiltroSexosBeneficio.TODOS || card.sex === gender
        );


      for (const card of this.cardDataReformaPensiones) {
        const beneficioAsignado = response.find((b) => card.listCodes.includes(b.tipoBeneficio));
        const aplica = !!beneficioAsignado;

        card.statusText = aplica
          ? "La siguiente información es para ti"
          : "Este beneficio no aplicaría para ti";
        card.statusClass = aplica ? "con-beneficios" : "sin-beneficios";
        card.infoBoxMessage = aplica
          ? beneficioAsignado.descripcion
          : NO_APLICA_BENEFICIOS_REFORMA_PENSIONES_MENSAJE[card.id as keyof typeof NO_APLICA_BENEFICIOS_REFORMA_PENSIONES_MENSAJE];
        card.codigoBackBeneficioOtorgado = aplica ? beneficioAsignado.tipoBeneficio : undefined;
      }

      this.codigosBackBeneficiosOtorgados = this.cardDataReformaPensiones
        .filter(card => card.codigoBackBeneficioOtorgado)
        .map(card => card.codigoBackBeneficioOtorgado!);

      this.showComponent = true;
      this.loadingHome = false;
      this.servsError = false;
    } catch (error) {
      console.error('Error al obtener el estado del trámite de pensión:', error);
      this.handleErrorState()
    }
  }

  onRetryEvent() {
    this.attempt = true;
    this.nAttempts++;
    if (this.nAttempts <= 3) {
      void this.getBeneficiosReformaPensiones();
    } else {
      this.router.navigate([INICIO]);
    }
  }

  onGoToEvent() {
    this.router.navigate([INICIO]);
  }

  private handleErrorState() {
    this.showComponent = false;
    this.loadingHome = true;
    this.servsError = true;
    this.attempt = false;
  }

  onBeneficioEvent(event: ICardReformaPensiones) {
    this.storageService.set(BENEFICIO_SELECCIONADO_REFORMAS, event);
    this.router.navigate([ROUTING_REFORMA_PENSIONES.REFORMA_PENSIONES_BASE,
    ROUTING_REFORMA_PENSIONES.BENEFICIOS_REFORMA_PENSIONES,
    ROUTING_REFORMA_PENSIONES.DETALLE_BENEFICIO_REFORMA]);

  }
  toggleHelp() {
    this.isOpenHelp = !this.isOpenHelp;
  }

  goToVideoAtencion() {
    this.router.navigate(['video-atencion']);
  }

  @HostListener("window:resize")
  onWindowResize() {
    this.isMobile = window.innerWidth < 840;
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
